// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'normalize.css'
import '@/assets/index.css'
// import '@/assets/rem.scss'
// import "@/assets/js/htmlFontSize.js"
import store from '@/store/index.js'
import 'babel-polyfill'
import './assets/animate.css'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
Vue.use(VueAwesomeSwiper)
Vue.use(ElementUI)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,

  template: '<App/>',
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js